import { useEffect } from "react";
import { Crisp } from "crisp-sdk-web";

const CrispChat = () => {
  useEffect(() => {
    const websiteId = process.env.REACT_APP_CRISP_WEBSITE_ID;

    if (!websiteId) {
      console.error("Crisp website ID is missing!");
      return;
    }
    Crisp.configure(websiteId);
    Crisp.load();

    // Optional: Set user info
    Crisp.user.setEmail("user@example.com");
    Crisp.user.setNickname("John Doe");

    // Cleanup
    return () => {
      Crisp.chat.close();
    };
  }, []);

  return null;
};

export default CrispChat;
